import { LockOffOutlineIcon } from './LockOffOutlineIcon';

/**
 * author: Colton Wiscombe
 * id AAC1BB51-BA46-4FB6-B901-F602E7C55351
 * name lock-off-outline
 * version: 5.7.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lock-off-outline.svg
 * tags
 * - Lock 
 */
export const UnsecureOutlineIcon = LockOffOutlineIcon;
export default UnsecureOutlineIcon